import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

const InfoMessageComponent = ({ value }) => (
  <Typography variant="body1">{value}</Typography>
);

InfoMessageComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

export default InfoMessageComponent;
